if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      const addOnItem = this.getAddOnItem();
      const request = () => fetch(`${routes.cart_add_url}`, config).then((response) => response.json());

      (addOnItem ? this.addWithAddOn(formData, addOnItem).then((response) => (response.status ? request() : response)) : request())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    // Optional buy box add-on (sgc-qcap-addon) linked to this form, or null.
    getAddOnItem() {
      // getAttribute: form.id would return the form's <input name="id">.
      const formId = this.form.getAttribute('id');
      const addOn = formId ? document.querySelector(`sgc-qcap-addon[data-form-id="${formId}"]`) : null;
      return addOn && typeof addOn.getCartItem === 'function' ? addOn.getCartItem() : null;
    }

    // Main product + add-on in one request. Shopify adds all items or none, so
    // a failed main product never leaves the add-on alone in the cart. On any
    // failure the caller retries the plain form, so the add-on never blocks the
    // main product.
    addWithAddOn(formData, addOnItem) {
      const item = { id: Number(formData.get('id')), quantity: Number(formData.get('quantity') || 1) };
      if (formData.get('selling_plan')) item.selling_plan = Number(formData.get('selling_plan'));
      const properties = {};
      for (const [key, value] of formData.entries()) {
        const match = key.match(/^properties\[(.+)\]$/);
        if (match && typeof value === 'string') properties[match[1]] = value;
      }
      if (Object.keys(properties).length) item.properties = properties;

      const body = { items: [item, addOnItem] };
      if (this.cart) {
        body.sections = this.cart.getSectionsToRender().map((section) => section.id);
        body.sections_url = window.location.pathname;
      }

      // Reply in the shape of a single add (main line item + sections), as the cart drawer/notification expect it.
      return fetch(`${routes.cart_add_url}.js`, { ...fetchConfig(), body: JSON.stringify(body) })
        .then((response) => response.json())
        .then((state) => {
          if (state.status || !state.items) return state.status ? state : { status: 'error' };
          const mainItem = state.items.find((line) => line.variant_id === item.id) || state.items[0];
          return { ...mainItem, sections: state.sections };
        })
        .catch(() => ({ status: 'error' }));
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
